import { graphClient } from '../../../graph-client'
import { UPDATE_USER_TASK_HOST_RESCUED } from './gql'
import type { RescuedHostTask } from './types'

class UserTaskHostRescued {
  async rescued(params: RescuedHostTask.Input) {
    const request = await graphClient.request<RescuedHostTask.Output>(
      UPDATE_USER_TASK_HOST_RESCUED,
      params,
    )

    return request?.updateUserTaskHostRescued
  }
}

export const userTaskHostRescuedService = new UserTaskHostRescued()
